// src/components/claims/GroupBlock.jsx
// One bordered block of a claims / sources panel: a tinted band with an optional kind
// tag (e.g. «Sottosezione»), the label as an <h4>, and a count on the right; then the
// rows. The tag sits outside the <h4> so the heading's name is the label alone.
import React from 'react';
import { COLORS, RADII } from '../../constants/theme.js';

export default function GroupBlock({ tag = null, label, countText, t = {}, w = (o) => `rgba(0,0,0,${o})`, children }) {
  const muted = t.textMuted || COLORS.textSecondary;
  return (
    <section style={{ marginTop: '12px', borderRadius: RADII.controlInner, border: `1px solid ${w(0.08)}`, overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', padding: '8px 12px', background: w(0.04), borderBottom: `1px solid ${w(0.06)}` }}>
        {tag && (
          <span style={{ flexShrink: 0, fontSize: '10px', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', color: muted }}>
            {tag}
          </span>
        )}
        <h4 style={{ margin: 0, flex: 1, fontSize: '13px', fontWeight: 600, color: t.text || COLORS.ink }}>{label}</h4>
        <span style={{ flexShrink: 0, fontSize: '11px', color: muted }}>{countText}</span>
      </div>
      <ul style={{ margin: 0, padding: '0 12px', listStyle: 'none' }}>
        {children}
      </ul>
    </section>
  );
}
